export default __webpack_public_path__ + "static/media/PMS.8125394c.png";